module.exports = __webpack_public_path__ + "media/assets/iconCall-75ad47bb540a16e61b8ccbacf67a7f78.png";